module.exports = __webpack_public_path__ + "img/01-Big Picture Thinker.8f856284.svg";